/* eslint-disable import/prefer-default-export */
import { ENDPOINTS } from './endpoints';
import { fetchData } from './network';
import { bindLocaleIntoHeaders } from '../utils/resolve-locale';

export function getCampusPage() {
  const url = new URL(`${process.env.API_URL}${ENDPOINTS.getCampusDetails.path}`);

  bindLocaleIntoHeaders(url);
  url.searchParams.append('populate[campus_and_community][populate]', '*');
  url.searchParams.append('populate[residential_experience][populate]', '*');
  url.searchParams.append('populate[co_curricular_programs][populate]', '*');
  url.searchParams.append('populate[amenity_slide][populate]', '*');
  url.searchParams.append('populate[housing_and_accommodation][populate]', '*');
  url.searchParams.append('populate[hero_image_1][populate]', '*');
  url.searchParams.append('populate[hero_image_2][populate]', '*');
  url.searchParams.append('populate[hero_line1][populate]', '*');
  url.searchParams.append('populate[hero_line2][populate]', '*');
  url.searchParams.append('populate[hero_description][populate]', '*');
  url.searchParams.append('populate[section_2_image][populate]', '*');
  url.searchParams.append('populate[section_5_image][populate]', '*');

  // TODO: Hide it as per client request. Enable it later.
  // url.searchParams.append('populate[student_dormitories_and_dining_hall][populate]', '*');

  return fetchData(url, {
    method: ENDPOINTS.getCampusDetails.method
  }).then((response) => response);
}
